import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Waqas Nasir </span>
            from <span className="purple"> Karachi, Pakistan.</span>
            <br /> I am a Full Stack Developer and passionate about web and tech in general, currently working in
            <span className="purple"> Deentek Solutions.</span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Listing To Music
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Tell me and I forget. Teach me and I remember. Involve me and I learn."{" "}
          </p>
          <footer className="blockquote-footer">Benjamin Franklin</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
